export const absolutify = path => new URL(path, document.baseURI).href